<template>
  <div>
    <myHeader />
    <div :class="secondStep ? 'test-box test-box-second' : 'test-box'" ref="testBg">
      <div class="test-container">
        <!--步骤条-->
        <div class="test-step">
          <div class="one-step">
            <div class="one-step-no chosen">1</div>
            <div class="one-step-name chosen-name">基础信息</div>
          </div>
          <div class="one-step-line"></div>
          <div class="one-step">
            <div :class="secondStep ? 'one-step-no chosen' : 'one-step-no'">2</div>
            <div :class="secondStep ? 'one-step-name chosen-name' : 'one-step-name'">信用自测</div>
          </div>
        </div>
        <!--主要内容区域-->
        <div>
          <!--第一步-->
          <div v-if="!secondStep" class="test-main-first">
            <el-form :model="basicForm" ref="basicForm" label-width="150px" label-position="right" class="basic-form">
              <el-form-item label="企业名称：" prop="companyName">
                <el-input class="login-input" v-model="basicForm.companyName" :placeholder="companyNameRuler" />
              </el-form-item>
              <el-form-item label="统一社会信用代码：" prop="uscCode">
                <el-input class="login-input" v-model="basicForm.uscCode" :placeholder="uscCodeRuler" />
              </el-form-item>
              <el-form-item label="企业类型：" prop="companyType">
                <el-input class="login-input" v-model="basicForm.companyType" :placeholder="companyTypeRuler" />
              </el-form-item>
              <el-form-item label="法定代表人：" prop="juridicalPerson">
                <el-input class="login-input" v-model="basicForm.juridicalPerson" :placeholder="juridicalPersonRuler" />
              </el-form-item>
              <el-form-item label="法人性质：" prop="legalNature">
                <el-select class="login-input" v-model="basicForm.legalNature" :placeholder="legalNatureRuler" clearable>
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="注册资本：" prop="registeredCapital">
                <el-input class="login-input" v-model="basicForm.registeredCapital"
                  :placeholder="registeredCapitalRuler" />
              </el-form-item>
              <el-form-item label="经营状态：" prop="businessStatus">
                <el-input class="login-input" v-model="basicForm.businessStatus" :placeholder="businessStatusRuler" />
              </el-form-item>
              <el-form-item label="注册日期：" prop="registrationDate">
                <el-date-picker class="login-input" v-model="basicForm.registrationDate" type="date"
                  value-format="yyyy-MM-dd" :placeholder="registrationDateRuler" />
              </el-form-item>
              <el-form-item label="登记机关：" prop="registrationAuthority">
                <el-input class="login-input" v-model="basicForm.registrationAuthority"
                  :placeholder="registrationAuthorityRuler" />
              </el-form-item>
              <el-form-item label="注册地址：" prop="registeredAddress">
                <el-input class="login-input" v-model="basicForm.registeredAddress"
                  :placeholder="registeredAddressRuler" />
              </el-form-item>
            </el-form>
          </div>
          <!--第二步-->
          <div v-else class="test-main-second">
            <!--左侧目录-->
            <div class="left">
              <div>
                <div :class="anchorIdx === index ? 'menu-selected comn-menu' : 'comn-menu'"
                  v-for="(menu, index) in menuList" v-bind:key="index" @click="changeMenu(index)">{{ menu.name }}</div>
              </div>
              <div class="menu-icon"><el-image :src="menuIcon"></el-image></div>
            </div>

            <!--右侧内容-->
            <div id="right">
              <!-- 接口查出来的 -->
              <div class="one-content" v-for="(item, index) in menuList" v-bind:key="index">
                <!-- 2、基础登记 -->
                <div class="one-content-title">
                  <div class="one-content-title-1">{{ item.name }}</div>
                </div>
                <!-- 申报须知的内容单独显示 -->
                <div v-show="index == 0" class="one-content-main">
                  申报须知：<br />
                  1、 养老机构可利用“养老机构服务信用评价指标体系数据报送工具”进行申报。<br />
                  2、 申报填写内容及提供资料须保证其真实完整无误。<br />
                  3、 申报书内各栏不得空项，无内容时文字部分须填“无”，数字部分填“0”。<br />
                  4、 如手工填写，要求字迹清晰，书写工整。<br />
                  5、 本表各栏如有填写不够处，请自行加栏或另附页。<br />
                  6、 如有支撑材料，请在电子版中注明并自行整理支撑材料打包上传系统，并保存备查。<br />
                  7、 填报数据除特殊标明外，均以填报之日计算以前连续三年的数据为准。
                </div>
                <div v-show="index > 0" class="one-content-main-2">
                  <div class="one-sub" v-for="sub in item.list" v-bind:key="sub.name">
                    <!-- 2-1 经营规模 -->
                    <div class="one-content-title-2" v-if="sub.name">{{ sub.name }}</div>
                    <!-- 资产规模 -->
                    <div class="one-exam" v-for="title in sub.titleList" v-bind:key="title.name">
                      <div class="one-exam-left">{{ title.name }}</div>
                      <el-radio-group v-model="title.selectId" class="one-exam-right">
                        <el-radio
                          :label="option.id"
                          class="one-exam-option"
                          v-for="option in title.optionList"
                          v-bind:key="option.name"
                          >{{ option.name }}</el-radio>
                      </el-radio-group>
                      <div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--底部按钮-->
          <div class="test-main-bottom">
            <el-checkbox v-if="secondStep" v-model="checked" class="xieyi-checkbox" />
            <div v-if="secondStep" class="xieyi">提交表示您已阅读并同意<a class="xieyi-a" @click="openAgreement">《养老机构服务信用评价协议》</a>
            </div>
            <div v-if="secondStep" class="btn test-save-storage" @click="saveDraft">保存草稿</div>
            <div v-if="!secondStep" class="btn primary-btn test-next-step" @click="toNext">下一步</div>
            <div v-else class="btn primary-btn" @click="toLast">上一步</div>
            <div v-if="secondStep" class="btn primary-btn test-submit-step" @click="doSubmit">提交</div>
          </div>
        </div>
      </div>
    </div>
    <myFooter bgc="black" />

    <!-- 协议窗口 -->
    <el-dialog title="养老机构服务信用自测协议" :visible.sync="agreementDialogFlag" width="55%" center>
      <div class="xieyi-1">一．本协议签订主体</div>
      <div class="xixeyi-2">本协议由烟台点点电子信息科技有限公司（以下统称“我方”）与使用本平台进行服务信用自测的养老机构签订，协议生效后对各方均具有法律约束力。</div>
      <div class="xieyi-1">二．本协议主要内容</div>
      <div class="xixeyi-2">本协议是养老机构服务信用评价平台养老机构信用自测服务的提供及使用规则。</div>
      <div class="xixeyi-2">（1）养老机构在使用自测系统时应保证数据的真实性，在系统中的提交的各个选项能客观地反映养老机构的经营状况。</div>
      <div class="xixeyi-2">（2）本自测结果仅作为养老机构评估自身服务信用水平的参考，不可用作其他任何用途，也不具有法律效力。</div>
      <div class="xixeyi-2">（3）我方有权对您填写的内容进行存储，并利用养老机构服务信用评价模型给出参考信用评分。</div>
      <div class="xixeyi-2">（4）除非得到您的授权或法律政策另有规定外，我方对涉及养老机构隐私的信息予以严格保密，不会对外披露任何隐私信息。</div>
    </el-dialog>
  </div>
</template>

<script>
import { examine, testBase, testBaseSubmit, saveDraft, commitExamine } from "@/api/common";

export default {
  name: "Test",
  data() {
    return {
      // 步骤二开启状态
      secondStep: false,
      checked: false,
      basicForm: {
        // 经营状态
        businessStatus: '',
        // 企业名称
        companyName: '',
        // 企业类型
        companyType: '',
        // 法定代表人
        juridicalPerson: '',
        // 法人性质
        legalNature: '',
        // 注册地址
        registeredAddress: '',
        // 注册资本
        registeredCapital: '',
        // 登记机关
        registrationAuthority: '',
        // 注册日期
        registrationDate: '',
        // 统一社会信用代码
        uscCode: ''
      },
      businessStatusRuler: "请输入经营状态",
      companyNameRuler: "请输入企业名称",
      companyTypeRuler: "请输入企业类型",
      juridicalPersonRuler: "请输入法定代表人",
      legalNatureRuler: "请选择法人性质",
      registeredAddressRuler: "请输入注册地址",
      registeredCapitalRuler: "请输入注册资本",
      registrationAuthorityRuler: "请输入登记机关",
      registrationDateRuler: "请选择注册日期",
      uscCodeRuler: "请输入统一社会信用代码",
      menuIcon: require('../../assets/menu-icon.png'),
      options: [
        {
          value: '1',
          label: "企业法人"
        },
        {
          value: '2',
          label: "民办非企业法人"
        },
        {
          value: '3',
          label: "事业单位法人"
        }
      ],
      // 默认选中的菜单
      anchorIdx: 0,
      menuList: [],
      // 协议弹窗
      agreementDialogFlag: false
    }
  },
  watch: {},
  created() {
    this.init();
  },
  mounted() {
    // 数据加载完之后，再监听 监听滚动事件
    // document.getElementById("right").addEventListener('scroll', this.onScroll, false)
    if (this.menuList.length > 0) {
      this.scroolListener()
    }
  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    document.getElementById("right").removeEventListener('scroll', this.onScroll)
  },
  methods: {
    // 切换菜单
    changeMenu(index) {
      // 切换当前菜单选中状态
      // this.anchorIdx = index
      // 右侧切换到对应的内容
      let contentArr = document.querySelectorAll('.one-content')
      // 找到当前菜单对应的右侧元素距离 外层div 的距离
      let num = contentArr[index].offsetTop
      // 让 外层div 滚动到 该内容的顶部位置 【220 是外层div距离页面窗口 body 的距离】
      document.getElementById("right").scrollTo({ left: 0, top: num - 220, behavior: 'smooth' })
    },
    // 滚动监听器
    onScroll() {
      // 获取当前文档流的滚动距离 scrollTop
      const scrollTop = document.getElementById("right").scrollTop
      // 取出左侧菜单对应的右侧全部元素
      const navContents = document.querySelectorAll('.one-content')
      // 取出所有对应元素 距离 外层div 的距离
      const offsetTopArr = []
      navContents.forEach((item, index) => {
        offsetTopArr.push(item.offsetTop - 220)
      })
      // 定义当前点亮的导航下标
      let navIndex = 0
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是n了
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n
        }
      }
      this.anchorIdx = navIndex
    },

    scroolListener() {
      document.getElementById("right").addEventListener('scroll', this.onScroll, false)
    },

    // 查询基础信息
    init() {
      // 获取基础信息字段
      testBase().then(res => {
        this.basicForm = res.data
      })
    },
    // 打开协议窗口
    openAgreement() {
      this.agreementDialogFlag = true
    },


    // 处理参数
    handleParams() {
      let params = []
      // 一级指标
      this.menuList.forEach(menu => {
        if (menu.list) {
          // 二级指标
          menu.list.forEach(sub => {
            if (sub.titleList) {
              // 题目
              sub.titleList.forEach(title => {
                // if (!title.selectId) {
                //   this.$alert('选项未选中', '提示', {
                //     confirmButtonText: '确定',
                //     callback: action => {
                //       this.$message({
                //         type: 'info',
                //         message: `action: ${ action }`
                //       });
                //     }
                //   });
                //   return
                // }
                if (title.selectId) {
                  title.optionList.forEach(option => {
                    if (title.selectId === option.id) {
                      params.push({
                        detailId: option.id,
                        itemId: option.itemId,
                        modelId: option.modelId,
                        treeId: option.treeId
                      })
                    }
                  })
                }
              })
            }
          })
        }
      })
      return params
    },

    // 保存草稿 参数
    saveDraft() {
      // 草稿参数
      let param = this.handleParams()
      saveDraft(param).then(res => {
        this.$message.success("保存草稿成功")
      })
    },
    // 下一步
    toNext() {
      if (this.checkParams()) {
        this.secondStep = true
        // 基础信息提交
        testBaseSubmit(this.basicForm).then(response => {
          this.getExams()
        })
      }
    },
    // 查询答题列表
    getExams() {
      let menuList = [{ name: "1. 申报须知" }]
      examine().then(res => {
        let contentList = res.data
        contentList.forEach(item => {
          // 正则替换 非政策 用 '、'
          item.name = item.name.replace(/、/g, '. ')
          menuList.push(item)
        })
      })
      this.menuList = menuList
      this.scroolListener()
    },
    // 通过校验返回 true,否则返回 false
    checkParams() {
      if (!this.basicForm.companyName) {
        this.$message.error(this.companyNameRuler)
        return false
      }
      if (!this.basicForm.uscCode) {
        this.$message.error(this.uscCodeRuler)
        return false
      }
      if (!this.basicForm.companyType) {
        this.$message.error(this.companyTypeRuler)
        return false
      }
      if (!this.basicForm.juridicalPerson) {
        this.$message.error(this.juridicalPersonRuler)
        return false
      }
      if (!this.basicForm.legalNature) {
        this.$message.error(this.legalNatureRuler)
        return false
      }
      if (!this.basicForm.registeredCapital) {
        this.$message.error(this.registeredCapitalRuler)
        return false
      }
      if (!this.basicForm.businessStatus) {
        this.$message.error(this.businessStatusRuler)
        return false
      }
      if (!this.basicForm.registrationDate) {
        this.$message.error(this.registrationDateRuler)
        return false
      }
      if (!this.basicForm.registrationAuthority) {
        this.$message.error(this.registrationAuthorityRuler)
        return false
      }
      if (!this.basicForm.registeredAddress) {
        this.$message.error(this.registeredAddressRuler)
        return false
      }
      return true
    },
    // 上一步
    toLast() {
      this.secondStep = false
    },
    // 提交 打分
    doSubmit() {
      if (!this.checked) {
        this.$message.error("请勾选阅读并同意协议")
        return
      }
      let param = this.handleParams()
      commitExamine(param).then(res => {
        this.$message.success("提交成功")
        this.$router.push({ name: 'testResult', params: res })
      })
    }
  }
}

</script>
<style scoped>
.xieyi-1 {
  margin-top: 20px;
  font-size: 16px;
  line-height: 26px;
}

.xixeyi-2 {
  padding-left: 20px;
  font-size: 14px;
  line-height: 18px;
}

/*第二步*/
.test-main-second {
  display: flex;
  margin: 10px auto;
  height: 824px;
}

.left {
  width: 210px;
  height: 794px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
  margin-right: 10px;
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.comn-menu {
  width: 160px;
  height: 40px;
  padding-left: 16px;
  font-size: 16px;
  font-weight: 400;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.menu-selected {
  border-radius: 8px;
  background: #ebf3ff;
  color: rgba(63, 140, 255, 1);
}

.menu-icon {
  width: 168px;
  height: 168px;
}

#right {
  overflow-y: auto;
  width: 980px;
  height: 800px;
  padding-top: 24px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 1);
}

.one-content {
  width: 920px;
  min-height: 300px;
  padding: 0 30px 0;
}
.one-content:last-child {
  padding-bottom: 50px;
}

.one-content-title {
  width: 100%;
  padding: 16px 0 12px;
  font-weight: 700;
}

.one-content-title-1 {
  font-size: 16px;
}

.one-sub {
  margin-bottom: 10px;
}

.one-content-title-2 {
  padding-bottom: 16px;
  font-size: 14px;
  font-weight: 700;
}

.one-content-main {
  min-height: 593px;
  border: 1px solid rgba(216, 224, 240, 1);
  padding: 21px 24px;
  font-weight: 400;
  line-height: 24px;
}

.one-exam {
  display: flex;
  flex-direction: row;
  width: 918px;
  min-height: 109px;
  border-top: 1px solid rgba(216, 224, 240, 1);
  border-left: 1px solid rgba(216, 224, 240, 1);
  border-right: 1px solid rgba(216, 224, 240, 1);
}

.one-exam:last-child {
  min-height: 109px;
  border-bottom: 1px solid rgba(216, 224, 240, 1);
}

.one-exam-left {
  font-size: 14px;
  font-weight: 400;
  width: 172px;
  display: flex;
  justify-content: left;
  align-items: center;
  padding-left: 24px;
  padding-right: 24px;
  /* padding-top: 43px;
  padding-left: 24px; */
  border-right: 1px solid rgba(216, 224, 240, 1);
  background: rgba(250, 251, 252, 1);
}

.one-exam-right {
  display: flex;
  flex-direction: column;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 28px;
  width: 652px;
  min-height: 109px;
  display: flex;
  justify-content: center;
}

.one-exam-option {
  line-height: 28px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

/deep/.el-radio {
  display: flex;
  align-items: center;
}
/deep/.el-radio .el-radio__label {
  word-wrap: break-word;
  word-break: break-all;
  white-space: pre-wrap !important;
}



.test-box {
  padding-top: 110px;
  width: 100%;
  height: 830px;
  background: rgba(244, 249, 253, 1);
}

.test-box-second {
  height: 1014px;
}

.test-container {
  width: 1200px;
  /* padding-top: 10px; */
  margin: 0 auto;
}

.test-step {
  height: 80px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
  font-size: 16px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.one-step {
  display: flex;
  align-items: center;
}

.one-step-no {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid rgba(153, 153, 153, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  line-height: 32px;
}

.chosen {
  background: rgba(63, 140, 255, 1);
  color: white;
  border: none;
}

.chosen-name {
  color: rgba(63, 140, 255, 1);
}

.one-step-line {
  margin: 0 16px;
  width: 192px;
  height: 1px;
  background: rgba(216, 224, 240, 1);
}

.test-main-first {
  width: 1200px;
  height: 600px;
  padding-top: 50px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 1);
  margin: 10px auto;
}

.basic-form {
  margin-left: 63px;
}

.el-form-item {
  margin-bottom: 0;
}

/deep/ .el-form-item__label {
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}

.el-input__inner {
  border: 1px solid rgba(216, 224, 240, 1);
  width: 400px;
  height: 40px;
  box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
}


.test-main-bottom {
  width: 1200px;
  height: 80px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.test-next-step {
  margin-right: 26px;
}

.test-submit-step {
  margin-right: 34px;
}





/*底部操作栏*/
.xieyi {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 14px;
  color: rgba(51, 51, 51, 1);
}

/*深度选择器*/
.xieyi-checkbox /deep/ .el-checkbox__inner {
  margin: 2px 16px 0 0;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(196, 196, 196, 1) !important;
}

.xieyi-a {
  color: rgba(63, 140, 255, 1);
}


/* 设置滚动条显示隐藏 */
::-webkit-scrollbar {
  width: 0px !important;
  height: 0px !important;
}

/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 5px;
  border-radius: 8px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5); */
  background-color: #fff;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(63, 140, 255, 0.8);
  /* -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5); */
}
</style>



// WEBPACK FOOTER //
// src/views/test/index.vue